import App from './App.vue'
import Vue from 'vue'
import { mount } from '../../lib/mount'
import { loadPolyfills } from '../../polyfills'
import { rootClassName } from './config'
import './App.css'
import globalEventStore from '../../lib/global-event-store'
import { featureTest } from '../../lib/feature-test'
import { Listener, checkHasVhBug } from '../../lib/vh-fix'
mount(rootClassName, init, loadPolyfills, featureTest)

function init(el, { sendGaEvent, sendError, polyfills, featureTests }) {
  const preloadedState = JSON.parse(el.getAttribute('data-preloaded-state'))
  const selfId = JSON.parse(el.getAttribute('data-metadata') || '{}').selfId
  const universeId = el.getAttribute('data-universe-id')
  globalEventStore.add(el.id, 'sendGaEvent', sendGaEvent)
  globalEventStore.add(el.id, 'sendError', sendError)
  logPolyfills(polyfills, sendGaEvent)
  logFeatureTests(featureTests, sendGaEvent)
  logIfHash(sendGaEvent)

  const app = new Vue({
    render: h => h(App),
    data: {
      id: el.id,
      universeId,
      selfId,
      props: { ...preloadedState }
    }
  })

  app.$mount(el.firstChild)

  fixVhBug(sendGaEvent)
}

function fixVhBug(sendGaEvent) {
  if (checkHasVhBug()) {
    sendGaEvent({ action: `HAS_VH_BUG` })
    const vhListener = new Listener()

    vhListener.listen(handleUpdate)
  }
}

function handleUpdate(vh) {
  try {
    const html = document.getElementsByTagName('html')[0]
    html.style.setProperty('--dh-vh', `${vh}px`)
  } catch (error) {
    console.error(error)
  }
}

function logPolyfills(polyfills, sendGaEvent) {
  const polyfillsLoaded = Object.keys(polyfills).filter(key => polyfills[key])
  polyfillsLoaded.forEach(polyfills => {
    sendGaEvent({ action: `POLYFILLS_LOADED/${polyfills}` })
  })
}

function logFeatureTests(featureTests, sendGaEvent) {
  const featuresNotSupported = Object.keys(featureTests).filter(key => featureTests[key])
  featuresNotSupported.forEach(feature => {
    sendGaEvent({ action: `FEATURE_NOT_SUPPORTED/${feature}` })
  })
}

function logIfHash(sendGaEvent) {
  try {
    if (!window.location.hash) return

    const hash = window.location.hash.substring(1).replace(/%20/g, ' ')
    sendGaEvent({ action: `ENTERED_WITH_HASH/${hash}` })
  } catch (_) {}
}
